import React, { Component } from 'react';
import './EditFAQ.css';
import iconpen from '../../../../image/iconpen.svg'
import closeicon from '../../../../image/closeicon.svg'
class EditFAQ extends Component {
    render() {
        return (
            <div className="EditFAQ">
            
                <p className="col-md-6 mt-2 p-0 fontsize4 font-weight-bold ">Edit FAQ</p>
                <hr />
                <div className="form-group col-lg-7  my-4">
                    <label htmlFor="question" className="fontsize12 text-muted">Type your question</label>
                    <input type="text" className="form-control badge-pill" id="question" aria-describedby="question" placeholder="Type your question" name="questionEN" value={this.props.state.questionEN} onChange={this.props.handleChange} />
                </div>
                <div style={{ fontSize: 12, color: "red"}}>
                    {this.props.state.questionENError}
                </div>
                <div className="form-group col-lg-7">
                    <label htmlFor="answer" className="fontsize12 text-muted">Type your answer</label>
                    <textarea className="form-control" id="exampleFormControlTextarea1 badge-pill" rows="5" placeholder="Type your answer" name="answerEN" value={this.props.state.answerEN} onChange={this.props.handleChange}></textarea>
                </div>
                <div style={{ fontSize: 12, color: "red"}}>
                    {this.props.state.answerENError}
                </div>
                <div className="rtl text-right">
                    <div className="form-group col-lg-7 mx-auto my-4">
                        <label htmlFor="question1" className="fontsize12 text-muted ">اكتب السؤال</label>
                        <input type="text" className="form-control badge-pill" id="question1" aria-describedby="question" placeholder="اكتب السؤال" name="questionAR" value={this.props.state.questionAR} onChange={this.props.handleChange} />
                    </div>
                    <div style={{ fontSize: 12, color: "red" ,textAlign: "center"}}>
                        {this.props.state.questionARError}
                    </div>
                    <div className="form-group mx-auto col-lg-7">
                        <label htmlFor="answer1 " className="fontsize12 text-muted">اكتب اجابة السؤال</label>
                        <textarea className="form-control" id="answer1 badge-pill" rows="5" placeholder="اكتب اجابة السؤال" name="answerAR" value={this.props.state.answerAR} onChange={this.props.handleChange}></textarea>

                    </div>
                    <div style={{ fontSize: 12, color: "red" ,textAlign: "center" }}>
                        {this.props.state.answerARError}
                    </div>
                </div>
                 <div className="text-center d-flex justify-content-around  flex-wrap my-3 col-md-8">

                    <button onClick={this.props.EditFAQ} className="btn badge-pill p-2 pl-1 px-3  m-1 border shadow bg-white " ><img className="mr-1" src={iconpen} alt="pen" />SAVE EDIT </button>
                    {/* <button className="btn badge-pill p-2 pl-1 px-4  m-1 border shadow  bg-white  " >CANCEL</button> */}
                    <button className="btn badge-pill p-2 pl-1 px-3 m-1 border shadow bg-danger text-white " onClick={this.props.handleDeleteFAQ}><img className="mr-1 " src={closeicon} alt="close" />DELETE</button>
             
                    </div>

            </div>

        )
    }
}
export default EditFAQ;